import * as tslib_1 from "tslib";
import { ChoiceGroup, } from 'office-ui-fabric-react/lib/ChoiceGroup';
import * as React from 'react';
import { observer } from 'mobx-react';
import { Image } from 'office-ui-fabric-react/lib/Image';
import { resolve as urlResolve } from 'url';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
var classnames = require('classnames');
var styles = require('./ChoiceGroupWithImages.scss');
var ChoiceItemWithImages = observer(function (props) {
    var option = props;
    return (React.createElement("div", { className: styles.option, style: { width: option.width + 4 + "px" } },
        React.createElement("span", { id: props.labelId, className: "ms-Label" }, props.text),
        React.createElement("div", { className: classnames(styles.imageContainer, 'flipForRtl', option.checked && styles.selected) },
            React.createElement(Image, { src: urlResolve(getPackageBaseUrl(), option.imageUri), className: styles.image, alt: "", role: "presentation" }))));
});
var ChoiceGroupWithImages = /** @class */ (function (_super) {
    tslib_1.__extends(ChoiceGroupWithImages, _super);
    function ChoiceGroupWithImages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRenderChoice = function (props) { return React.createElement(ChoiceItemWithImages, tslib_1.__assign({}, props)); };
        return _this;
    }
    ChoiceGroupWithImages.prototype.render = function () {
        var _this = this;
        return (React.createElement(ChoiceGroup, tslib_1.__assign({}, this.props, { className: classnames(this.props.className, styles.choiceGroup), options: this.props.options &&
                this.props.options.map(function (option) {
                    return (tslib_1.__assign({}, option, { onRenderLabel: _this.onRenderChoice }));
                }) })));
    };
    ChoiceGroupWithImages = tslib_1.__decorate([
        observer
    ], ChoiceGroupWithImages);
    return ChoiceGroupWithImages;
}(React.Component));
export default ChoiceGroupWithImages;
//# sourceMappingURL=ChoiceGroupWithImages.js.map